import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Icon from 'shopper/components/Icon';

import Tag from './Tag';

import APP from 'constants/app';

const TYPES = {
  primary:
    'bg-primary-300 before:top-0 before:left-1/2 before:rotate-180 before:-translate-x-1/2 pt-20 md:before:left-[-9px] md:before:top-1 md:before:rotate-[135deg] md:before:translate-x-0',
  secondary:
    'bg-secondary-300 before:bottom-0 before:left-1/2 before:rotate-0 before:-translate-x-1/2 pb-20 md:before:left-[unset] md:before:-right-2 md:before:bottom-1 md:before:translate-x-0 md:before:-rotate-45',
};

const Card = ({ type, heading, tags }) => (
  <div
    className={twJoin(
      'w-full rounded-5 px-6 py-8 md:w-1/2',
      TYPES[type],
      'relative before:absolute before:h-12 before:w-18 before:bg-[image:var(--polygon)] before:content-empty'
    )}
    style={{
      '--polygon': `url(${APP.LOCAL_IMAGE_PATH}/features/commercial-partners/${
        type === 'primary' ? 'blue-polygon.svg' : 'purple-polygon.svg'
      })`,
    }}
  >
    {heading}
    <div className="mt-6 flex flex-wrap justify-center gap-4 md:gap-8">
      {tags.map(({ icon, text }) => (
        <Tag key={text} iconLeft={<Icon name={icon} />} type={type}>
          {text}
        </Tag>
      ))}
    </div>
  </div>
);

Card.propTypes = {
  heading: PropTypes.node.isRequired,
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    })
  ).isRequired,
  type: PropTypes.string.isRequired,
};

export default Card;
